const BRAND_ICONS = new Set([
  'fa-whatsapp',
  'fa-telegram',
  'fa-telegram-plane',
  'fa-instagram',
  'fa-linkedin',
  'fa-skype',
]);

/** آیکون‌های قدیمی FA5 که در FA6 تغییر نام داده‌اند */
const FA_ICON_ALIASES = {
  'fa-mobile-alt': 'fa-mobile-screen',
  'fa-file-alt': 'fa-file-lines',
  'fa-phone-alt': 'fa-phone',
  'fa-pencil-alt': 'fa-pencil',
  'fa-calendar-alt': 'fa-calendar-days',
};

export { BRAND_ICONS as BRAND_FA_ICONS };

const resolveIconAlias = (iconName) => FA_ICON_ALIASES[iconName] || iconName;

/** کلاس Font Awesome — سازگار با FA6 (fa-solid) و FA5 (fas) */
export const normalizeFaIconClass = (icon) => {
  if (!icon) return '';
  let raw = String(icon).trim();
  if (!raw) return '';

  raw = raw.replace(/^fa\s+/, '');

  if (/^(fa-solid|fa-regular|fa-brands|fas|far|fab)\s+fa-/.test(raw)) {
    return raw
      .replace(/^fas\s+/, 'fa-solid ')
      .replace(/^far\s+/, 'fa-regular ')
      .replace(/^fab\s+/, 'fa-brands ');
  }

  const iconName = raw.startsWith('fa-') ? raw : `fa-${raw}`;
  const resolvedName = resolveIconAlias(iconName);
  const prefix = BRAND_ICONS.has(resolvedName) ? 'fa-brands' : 'fa-solid';
  return `${prefix} ${resolvedName}`;
};

/**
 * کلاس‌های قابل استفاده روی <i> — هم FA5 (fas/fab) و هم FA6
 * LeadSettings از fa-phone ذخیره می‌کند؛ هر دو فرمت پشتیبانی می‌شود.
 */
export const resolveFaIconClasses = (icon) => {
  if (!icon) return null;
  const raw = String(icon).trim();
  if (!raw) return null;

  if (/^(fas|far|fab)\s+fa-/.test(raw)) {
    const brand = raw.startsWith('fab ');
    return { className: raw, brand };
  }

  const normalized = normalizeFaIconClass(raw);
  if (!normalized) return null;

  const parts = normalized.split(/\s+/);
  const iconName = parts.find((p) => p.startsWith('fa-') && p !== 'fa-solid' && p !== 'fa-regular' && p !== 'fa-brands');
  if (!iconName) return null;

  const resolvedName = resolveIconAlias(iconName);
  const brand = normalized.includes('fa-brands') || BRAND_ICONS.has(resolvedName);
  const prefix = brand ? 'fab' : 'fas';
  return { className: `${prefix} ${resolvedName}`, brand };
};
